import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('fragment', [_vm.label ? _c('Label', _vm._b({
    attrs: {
      "html-for": _vm.id,
      "bold": _vm.labelBold,
      "disabled": _vm.disabled
    }
  }, 'Label', _vm.labelProps, false), [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), !_vm.mask ? _c('b-input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "id": _vm.id,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "minlength": _vm.minlength,
      "type": _vm.type,
      "max": _vm.max
    },
    on: {
      "input": _vm.updateValue,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleOnEnter.apply(null, arguments);
      }
    }
  }) : _c('b-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.mask,
      expression: "mask"
    }],
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "id": _vm.id,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "minlength": _vm.minlength,
      "type": _vm.type
    },
    on: {
      "input": _vm.updateValue,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleOnEnter.apply(null, arguments);
      }
    }
  }), _vm.description ? _c('div', {
    staticClass: "input-description input-margin",
    class: _vm.descriptionClass
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };